export const OTHER = "OTHER";

export enum ApplicationStepId {
  applicationType = "application-type",
  leadWall = "detail",

  buildAHouseHaveFoundLandplot = "build-a-house-have-found-landplot",
  buildAHouseWhereLandplot = "build-a-house-where-landplot",
  buildAHouseWhereLandplotOwner = "build-a-house-where-landplot-owner",
  buildAHousePurchasePrice = "build-a-house-purchase-price",
  buildAHouseTypeOfProperty = "build-a-house-type-of-property",
  buildAHouseConstructionCosts = "build-a-house-construction-costs",
  buildAHouseDownPayment = "build-a-house-down-payment",
  buildAHouseMonthlyNetIncome = "build-a-house-monthly-net-income",

  buyWithSavingsTypeOfProperty = "buy-with-savings-type-of-property",
  buyWithSavingsWhereToBuy = "buy-with-savings-where-to-buy",
  buyWithSavingsPurchasePrice = "buy-with-savings-purchase-price",
  buyWithSavingsDownPayment = "buy-with-savings-down-payment",
  buyWithSavingsMonthlyNetIncome = "buy-with-savings-monthly-net-income",

  refinancingWhereIsProperty = "refinancing-where-is-property",
  refinancingWhatMarketValue = "refinancing-what-market-value",
  refinancingLoanAmount = "refinancing-loan-amount",
  refinancingLoanDate = "refinancing-loan-date",
  refinancingMonthlyNetIncome = "refinancing-monthly-net-income",
}
